export const SAVE_STRIPE_ACCOUNT_INFO = 'SAVE_STRIPE_ACCOUNT_INFO'
export const SAVE_BANK_ACCOUNT_ERROR = 'SAVE_BANK_ACCOUNT_ERROR'
export const SAVE_BANK_ACCOUNT_SUCCESS = 'SAVE_BANK_ACCOUNT_SUCCESS'
export const STRIPE_ACCOUNT_CREATED = 'STRIPE_ACCOUNT_CREATED'
export const SAVE_STRIPE_API_KEY = 'SAVE_STRIPE_API_KEY'
